import { render, staticRenderFns } from "./PlatformView.vue?vue&type=template&id=80e658ce&scoped=true"
import script from "./PlatformView.vue?vue&type=script&lang=js"
export * from "./PlatformView.vue?vue&type=script&lang=js"
import style0 from "./PlatformView.vue?vue&type=style&index=0&id=80e658ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e658ce",
  null
  
)

export default component.exports